import request from '@/utils/fetch'

// 2021-1-20 查询所有工作域 只带园所
export function getAllWorkAreasNotDept () {
  return request({
    url: '/homePage/getAllWorkAreasNotDept',
    method: 'GET'
  })
}

// 获取服务器时间
export function getSystemTime () {
  return request({
    url: '/common/getSystemTime',
    method: 'GET'
  })
}

// 查询字典
export function searchDictoryInfoByCode (data) {
  return request({
    url: '/common/getDictoryInfoByCode',
    method: 'POST',
    params: data
  })
}

// 当前工作区域查询不含部门(分级)
export function searchWorkAreasScaleRes () {
  return request({
    url: '/homePage/getWorkAreasScaleRes',
    method: 'GET'
  })
}

// 当前工作区域查询含部门(分级)
export function getWorkAreasScaleDept () {
  return request({
    url: '/homePage/getWorkAreasScaleDept',
    method: 'GET'
  })
}

// 组织机构查询(type:1所有，4部门)
export function getAllOrganization (data) {
  return request({
    url: '/organization/getAllOrganization',
    method: 'GET',
    params: data
  })
}

// 查询所有工作域 带部门
export function getAllWorkAreasDept () {
  return request({
    url: '/homePage/getAllWorkAreasDept',
    method: 'get'
  })
}

// 图片/文件上传
export function uploadFile (data) {
  return request({
    url: '/PC/file/uploadFile',
    method: 'post',
    data
  })
}

// 处理富文本编辑器 文本
export function txtCatchimage (data) {
  return request({
    url: '/ueditor/txtCatchimage',
    method: 'post',
    data
  })
}

// 根据机构类型查询园所或公司(树结构) 3:园所;5公司
export function queryOrgOrCompany (data) {
  return request({
    url: `/accountManager/queryOrgOrCompany/${data}`,
    method: 'GET'
  })
}

// 工作域为片区，根据机构类型查询园所或公司(树结构) 3:园所;5公司 2片区
export function queryOrgOrCompanyByArea (data) {
  return request({
    url: `/accountManager/queryOrgOrCompanyByArea/${data}`,
    method: 'GET'
  })
}

// 根据机构和账户类型查询帐号
export function queryAccountByOrgIdAndType (data) {
  return request({
    url: `/fundflowCommon/queryAccountByOrgIdAndType`,
    method: 'GET',
    params: data
  })
}
// 根据机构,缴费方式和账户类型查询帐号
export function queryAccountByOrgIdAndTypeAndChargeForm (data) {
  return request({
    url: `/fundflowCommon/queryAccountByOrgIdAndTypeAndChargeForm`,
    method: 'GET',
    params: data
  })
}

// 查询账号类型
export function queryAccountType () {
  return request({
    url: `/fundflowCommon/queryAccountType`,
    method: 'GET'
  })
}
// 查询组织详情
export function queryOrganizationById (id) {
  return request({
    url: `/organization/queryById?id=${id}`,
    method: 'GET'
  })
}

// 根据机构和账户类型查收款类型
export function queryBookTrands (data) {
  return request({
    url: `/fundflowCommon/queryBookTrands`,
    method: 'GET',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/api_commonController.js